import { MdAddBox } from "react-icons/md";
import { MdArrowDownward } from "react-icons/md";
import { MdCheck } from "react-icons/md";
import { MdChevronLeft } from "react-icons/md";
import { MdChevronRight } from "react-icons/md";
import { MdClear } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { MdFilterList } from "react-icons/md";
import { MdFirstPage } from "react-icons/md";
import { MdLastPage } from "react-icons/md";
import { MdRemove } from "react-icons/md";
import { MdSave } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { MdViewColumn } from "react-icons/md";
import React, { forwardRef } from "react";

export const tableIcons = {
  Add: forwardRef((props, ref) => <MdAddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <MdCheck {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <MdClear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <MdDelete {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <MdChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <MdEdit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <MdSave {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <MdFilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <MdFirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <MdLastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <MdChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <MdChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <MdClear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <MdSearch {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => (
    <MdArrowDownward {...props} ref={ref} />
  )),
  ThirdStateCheck: forwardRef((props, ref) => (
    <MdRemove {...props} ref={ref} />
  )),
  ViewColumn: forwardRef((props, ref) => <MdViewColumn {...props} ref={ref} />),
};
